// export const BASE_URL = 'http://192.168.1.5/notes_web/api/';
// export const BASE_URL = 'https://192.168.1.5/notes_web/api/';
export const BASE_URL = 'https://talechronicles.com/apis/api/';
export const USER_AVATAR_URL = 'https://talechronicles.com/apis/uploads/avatars/';
export const CATEGORY_ICON_URL = 'https://talechronicles.com/apis/uploads/category-icons/';